import { ApiResponseJuspayMeta, BOOLEAN_AS_STRING } from "@swiggy-private/payment-types";
import {
    BankData,
    BannerData,
    IHalfCardAwareness,
    OffersStripBody,
    PaymentGroupData,
    PaymentGroupMeta,
    PaymentMethod,
    PaymentMethodDowntime,
    PaymentMethodMeta,
    SplitPayData,
} from "@swiggy-private/payment-ui";
import { BillToCompanyWidgetData } from "@swiggy-private/checkout-types";
import { TurboStripData } from "@swiggy-private/core-ui";

import { CredOfferLayerDetailsInterface } from "@swiggy-private/native-bridge";

export enum FRICTION_LAYOUT_ID {
    CONTROL = "control",
    TWO_CLICK = "two_click",
    THREE_CLICK = "three_click",
}

export interface PresentationDetails {
    deliverySla?: string;
    deIcon?: string;
    deliveryAddress: {
        address: string;
        annotation: string;
        name: string;
    };
    pickUpAddress: {
        address: string;
        annotation: string;
        name: string;
    };
    deliveryTimeAnnotation?: string;
    deliveryTime?: string;
    headerTitle?: string;
    headerSubtitle?: string;
    discountMessage?: string;
}

export interface GetPaymentMethodsResponse {
    tenant: string;
    paymentGroup: PaymentGroupData<PaymentGroupMeta, PaymentMethod<PaymentMethodMeta>>[];
    itemQuantity: number;
    codEnabled: boolean;
    paymentPageOfferEnabled?: boolean;
    paymentBannerMessage?: string;
    paymentAmount: string;
    paymentAmountWithPayDiscount?: string;
    paymentAmountWithoutDiscount: string;
    paymentAmountChanged: boolean;
    couponApplied: boolean;
    rewardApplied: boolean;
    couponCode?: string;
    paymentCouponCode?: string;
    // earlier we are building payment page header copy ourselves for coupon code offer applied
    // this is not scalable for MRO and AIP cases and for future needs of dynamic offer texts moved to a dedicated backend field
    offerHeaderText?: string;
    juspayMeta: ApiResponseJuspayMeta;
    splitpayGroupDisplayName?: string;
    splitpayList?: SplitPayData[];
    banner?: BannerData;
    paymentMethodDowntime?: PaymentMethodDowntime;
    paymentAmountWithSplitpay?: string;
    paymentAmountWithSplitpayWithoutDiscount?: string;
    frictionLayoutId?: FRICTION_LAYOUT_ID;
    frictionViewMorePaymentSubtext?: string;
    presentationDetails?: PresentationDetails;
    offerBanner?: OffersStripBody;
    paymentOffersGroup?: PaymentGroupData<PaymentGroupMeta, PaymentMethod<PaymentMethodMeta>>[];
    XPData?: XPData; // Old XP object, to be deprecated
    newUser?: boolean;
    xpData?: XPData;
    shouldShowThirdPartyUpiIntentApps?: boolean;
    flipkartCoinsEligible?: boolean;
    halfCardAwareness?: IHalfCardAwareness;
    credRewardsLayer?: CredOfferLayerDetailsInterface;
    tooltip?: {
        text?: string;
        enabled?: boolean;
        key?: string;
        icon?: string;
    };
    turboStrip?: TurboStripData;
    rewardsEnabled?: boolean;
    billToCompanyWidgetData?: BillToCompanyWidgetData;
}

export interface XPData {
    [key: string]: unknown;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    payment_abandonment_feedback?: BOOLEAN_AS_STRING;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    upiIntentShowCancel?: BOOLEAN_AS_STRING;
    nuPpmUpi?: string;
}

export interface BankListData {
    bankList: BankData[];
}

export const POLLING_TXN_STATUS = {
    FAILED: "FAILED",
    PENDING: "PENDING",
    SUCCESS: "SUCCESS",
    NOT_INITIATED: "NOT-INITIATED",
};
